import { Button } from "../../../components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "../../../components/ui/dialog";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "../../../components/ui/popover";
import type { ExtendedEventViewT } from "../../../types/database/events";
import useDeleteEventMutation from "../api/deleteEvent";
import EditEvent from "./EditEvent";
import { MoreVertical, Trash2 } from "lucide-react";

interface EventInHistoryProps {
	event: ExtendedEventViewT;
	index: number;
}

const EventInHistory = ({
	event,
	index,
}: EventInHistoryProps) => {
	const deleteEvent = useDeleteEventMutation(event.event_id);

	return (
		<div
			key={event.event_id}
			className="space-y-2 dark:bg-slate-900 shadow-sm px-4 py-4 rounded-lg w-full event-card"
		>
			{/* Event Header */}
			<div className="mb-4">
				<div className="flex flex-row justify-between items-start w-full">
					<h3 className="mb-2 font-semibold text-xl">
						{event.event_name ?? `Event #${index + 1}`}
					</h3>

					<Popover>
						<PopoverTrigger asChild>
							<Button variant="ghost" size="icon">
								<MoreVertical className="w-4 h-4" />
							</Button>
						</PopoverTrigger>
						<PopoverContent align="end" className="p-1 w-auto">
							<Dialog>
								<DialogTrigger asChild>
									<Button
										type="button"
										variant="ghost"
										size="sm"
										className="flex justify-start items-center w-full text-red-500 hover:text-red-600"
									>
										<Trash2 className="mr-2 w-4 h-4" />
										<span>Delete</span>
									</Button>
								</DialogTrigger>
								<DialogContent>
									<DialogHeader>
										<DialogTitle>
											Are you absolutely sure?
										</DialogTitle>
										<DialogDescription>
											This action cannot be undone. This
											will permanently delete this event
											and all its data.
										</DialogDescription>
									</DialogHeader>
									<DialogFooter>
										<Button
											variant="destructive"
											onClick={() =>
												deleteEvent.mutate(
													event.event_id,
												)}
										>
											Delete
										</Button>
									</DialogFooter>
								</DialogContent>
							</Dialog>
						</PopoverContent>
					</Popover>
				</div>
				<EditEvent event={event} />
			</div>
		</div>
	);
};

export default EventInHistory;
